var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChauffeur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/overview/chauffeur") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,0.437 C13.432,0.437 0,13.869 0,30.437 L0,30.437 C0,47.006 13.432,60.438 30,60.438 L30,60.438 C46.569,60.438 60,47.006 60,30.437 L60,30.437",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.437 C13.432,0.437 0,13.869 0,30.437 L0,30.437 C0,47.006 13.432,60.438 30,60.438 L30,60.438 C46.569,60.438 60,47.006 60,30.437 L60,30.437 C60,13.869 46.569,0.437 30,0.437 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.437 C13.432,0.437 0,13.869 0,30.437 L0,30.437 C0,47.006 13.432,60.438 30,60.438 L30,60.438 C46.569,60.438 60,47.006 60,30.437 L60,30.437 C60,13.869 46.569,0.437 30,0.437 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.437 C13.432,0.437 0,13.869 0,30.437 L0,30.437 C0,47.006 13.432,60.438 30,60.438 L30,60.438 C46.569,60.438 60,47.006 60,30.437 L60,30.437 C60,13.869 46.569,0.437 30,0.437 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "States-&-Styles-&-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets---Icons",
    transform: "translate(-176.000000, -400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/overview/principal",
    transform: "translate(176.000000, 400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 0.562600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4731,29.1029 C34.3511,29.1029 38.3061,25.1489 38.3061,20.2699 C38.3061,15.3919 34.3511,11.4369 29.4731,11.4369 C24.5941,11.4369 20.6401,15.3919 20.6401,20.2699 C20.6401,25.1489 24.5941,29.1029 29.4731,29.1029",
    id: "Fill-1",
    fill: "#444B68",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8071,70.9998 L11.8071,44.9088 L11.8071,43.7078 C11.8071,37.2468 17.1591,32.0098 23.7611,32.0098 L24.3001,32.0098 L24.3031,70.4418 L11.8071,70.9998 Z",
    id: "Fill-4",
    fill: "#444B68",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1387,70.9998 L47.1387,44.9088 L47.1387,43.7078 C47.1387,37.2468 41.7867,32.0098 35.1847,32.0098 L34.6457,32.0098 L34.6427,70.4418 L47.1387,70.9998 Z",
    id: "Fill-7",
    fill: "#444B68",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5479,32.0096 L29.1379,34.6346 L26.7699,60.5896 L30.9279,60.5896 C31.2339,60.2476 31.6589,59.9716 32.1559,59.7756 L29.8069,34.6346 L32.3979,32.0096 L26.5479,32.0096 Z",
    id: "Fill-10",
    fill: "#444B68",
    mask: "url(#mask-8)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M30,0.9999 C13.432,0.9999 0,14.4319 0,30.9999 C0,47.5679 13.432,60.9999 30,60.9999 C46.568,60.9999 60,47.5679 60,30.9999 C60,14.4319 46.568,0.9999 30,0.9999 M30,2.9999 C45.439,2.9999 58,15.5609 58,30.9999 C58,46.4389 45.439,58.9999 30,58.9999 C14.561,58.9999 2,46.4389 2,30.9999 C2,15.5609 14.561,2.9999 30,2.9999",
    id: "Fill-14",
    fill: "#444B68"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChauffeur);
export default __webpack_public_path__ + "static/media/chauffeur.0ef2473db7221ea71885fd2d739ceb2a.svg";
export { ForwardRef as ReactComponent };